import React from "react"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { PasswordRecoverySuccess as PasswordRecoverySuccessForm } from "ui/auth/PasswordRecovery/Success"

export const PasswordRecoverySuccess = () => (
  <AuthenticationLayout type="signin">
    <PasswordRecoverySuccessForm />
  </AuthenticationLayout>
)
